import React, { Component } from 'react';
import '../Css/Style.css';
import {getData, postFormData} from '../Api/Config';
import SelectPublisher from './SelectPublisher';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import CirclePreloader from '../layouts/CirclePreloader'

class AddAppForm extends Component{
    
    componentDidMount(){
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {});
        this.Publishers();
        if(this.props){
        const ID = this.props.match.params.id?this.props.match.params.id:"";
        // console.log(ID); 
        if(ID!==""){
            this.GetData();   
        }else{
        
        }
    }
    }

    state={
        title:"",
        appName:"",
        appPackageName:"",
        publisherid:"",
        logoUrl: "",
        platform:"",
        firebaseJsonFile:[],
        publisherList:[],
        status:"",

        appName_err:"",
        appPackageName_err: "",
        publisherid_err:"",
        logoUrl_err:"",
        appInitializerName_err:"",
        firebaseJsonFile_err:"",
        platform_err:"",
        status_err:"",
        isloader:false
 }
validate=()=>{
    let Flag = true;
    if(this.state.appName===""){
        this.setState({
            appName_err:'* empty App Name! *'
        })
        Flag=false;
    }else{
        this.setState({
            appName_err:''
        });
    }

    if(this.state.appPackageName===""){
        this.setState({
            appPackageName_err:'* empty App Package Name! *'
        })
        Flag=false;
    }else{
        this.setState({
            appPackageName_err:''
        });
    }

    if(this.state.logoUrl===""){
        this.setState({
            logoUrl_err:'* empty Logo Url! *'
        })
        Flag=false;
    }else{
        this.setState({
            logoUrl_err:''
        });
    }
    
    if(!this.state.firebaseJsonFile || this.state.firebaseJsonFile.length===0){
        this.setState({
            firebaseJsonFile_err:'* empty Json File Name! *'
        })  
        Flag=false;
    }else if(!this.state.firebaseJsonFile.name.match(/\.(json)$/)){
        this.setState({
            firebaseJsonFile_err:" * Need a json file!"
        });
        Flag=false;
    }else{
        this.setState({
            firebaseJsonFile_err:''
        });
    }

    if(this.state.publisherid==='DEFAULT_VALUE' || this.state.publisherid===''){
        this.setState({
            publisherid_err:'* choose a publisher.....!*'
        })  
        Flag=false;
    }else{
        this.setState({
            publisherid_err:''
        });
    }

    if(this.state.platform==='DEFAULT_VALUE' || this.state.platform===''){
        this.setState({
            platform_err:'* choose a platform.....!*'
        })  
        Flag=false;
    }else{
        this.setState({
            platform_err:''
        });
    }

    if(this.state.status==='DEFAULT_VALUE' || this.state.status===''){
        this.setState({
            status_err:'* choose a status.....!*'
        })  
        Flag=false;
    }else{
        this.setState({
            status_err:''
        });
    }

    return  Flag;
}
handleChange=(e)=>{
    //for error check message
    // this.validate()

    //checking value to set in state
    if(e.target.id==="firebaseJsonFile"){
        const file = e.target.files[0];
        if(file){
            if(!file.name.match(/\.(json)$/)){
                e.target.value=null;
                this.setState({
                    firebaseJsonFile_err:" * Need a json file!"
                })
            }else{
                this.setState({
                    firebaseJsonFile_err:""
                })
                this.setState({
                    [e.target.id]:file 
                })
            }
        }
    }else{
    this.setState({
        [e.target.id]:e.target.value
     })
    }
}

 Publishers = async ()=>{
   await getData('publishers').then(res=>{
      this.setState({publisherList:res.publishers})
    })
    .catch(err=>{
        console.log(err);
    })   
}

handleSubmit = (e) =>{
     e.preventDefault();
    if(this.validate()){ 
        this.setState({isloader:true});
      let msg = "Added successfully.....!" 
    //   console.log(this.state)
       var formData = new FormData();
       formData.append('appId', this.state.appPackageName);
       formData.append('name', this.state.appName);
       formData.append('publisherId', parseInt(this.state.publisherid));
       formData.append('platform',this.state.platform);
       formData.append('status', this.state.status);
       formData.append('googleServicesJsonFile', this.state.firebaseJsonFile);
       formData.append('logoUrl',this.state.logoUrl);
       
     postFormData('apps',formData).then(res=>{
        this.setState({isloader:false});
            if(res)
            {
            M.toast({html: msg});
            this.props.history.push("/admin/AppDetails");
            }
     }).catch(err=>{
         console.log(err);
        this.setState({isloader:false});
        M.toast({html: "Failed to add this app!"});
        })
      }
    }

    GetData= async ()=>{
        const ID = this.props.match.params.id;
    const data = await getData(`apps/${ID}`).then(res=> res).catch(err=>err);
        if(data){
        // console.log(data);
        
            this.setState({
            appName:data.name,
            logoUrl:data.logoUrl,
            platform:data.platform,
            appPackageName:data.appId,
                });
        
        }
    }

render(){
return (

                <div className="card hoverable">
               
                  <div  className="card-content"  style={{padding:40}}>
                     <div>   
                    <span className="card-title center">{this.props.match.params.id?"Edit App":"Add App"}</span>
                    <hr/>
                    <div className="row">
                        <div className="col-12" style={{marginTop:10}}>
                            <form onSubmit={(e)=>this.handleSubmit(e)}>
                            <div className="row">
                                <div className="input-field col s6">
                                <input placeholder="Enter App Name" id="appName" type="text" className="validate" value={this.state.appName} onChange={this.handleChange}/>
                                <label className="active" htmlFor="app_name">App Name</label>
                                <div style={{fontSize:12 ,color:"red"}}>{this.state.appName_err}</div>
                                </div>
                                <div className="input-field col s6">
                                <input id="appPackageName" placeholder="Enter App Package Name" type="text" className="validate" value={this.state.appPackageName} onChange={this.handleChange}/>
                                <label className="active" htmlFor="app_package_name">App Package Name</label>
                                <div style={{fontSize:12 ,color:"red"}}>{this.state.appPackageName_err}</div>
                                </div>
                            </div>
                            <div className="row">
                            <div className="input-field col s12">
                                
                            <select defaultValue={this.state.publisherid}  id="publisherid" onChange={this.handleChange} >
                            <option value="DEFAULT_VALUE">Select Publisher... </option>   
                                {this.state.publisherList && this.state.publisherList.map((pub)=>{
                                    return <SelectPublisher pub ={pub} key = {pub.id}/>
                                })}
                               </select>
                               <div style={{fontSize:12 ,color:"red"}}>{this.state.publisherid_err}</div>
                               </div>
                                
                            </div>
                            <div className="row">
                                <div className="input-field col s12">
                                <input id="logoUrl" type="text" className="validate" placeholder="Enter Logo Url" value={this.state.logoUrl} onChange={this.handleChange}/>
                                <label className="active" htmlFor="logo_url">Logo Url</label>
                                <div style={{fontSize:12 ,color:"red"}}>{this.state.logoUrl_err}</div>
                                </div>
                            </div>
                            <div className="row">
                               <div className="input-field col s12">
                                <select defaultValue="DEFAULT_VALUE" id="platform" onChange={this.handleChange}>
                                <option value="DEFAULT_VALUE">Select platform... </option>
                                <option value="ANDROID">Android</option>
                                <option value="IOS">iOS</option>       
                            </select>
                            <div style={{fontSize:12 ,color:"red"}}>{this.state.platform_err}</div>
                                </div>
                            </div>

                            <div className="row">
                               <div className="input-field col s12">
                                <select defaultValue="DEFAULT_VALUE" id="status" onChange={this.handleChange} >
                                <option value="DEFAULT_VALUE">Select App Status... </option>
                                <option value="ICE_BOX">Ice Box</option>
                                <option value="TODO">To Do</option>   
                                <option value="IN_PROGRESS">In Progress</option>
                                <option value="IN_REVIEW">In Review</option>   
                                <option value="COMPLETED">Completed</option>
                                <option value="LIVE">Live</option>       
                            </select>
                            <div style={{fontSize:12 ,color:"red"}}>{this.state.status_err}</div>
                                </div>
                            </div>

                            <div className="row">
                            <div className="file-field input-field">
                                <div className="btn blue-grey">
                                    <span>File</span>
                                    <input type="file"  id="firebaseJsonFile" onChange={this.handleChange}/>
                                </div>
                                <div className="file-path-wrapper">
                                    <input className="file-path validate" type="text"/>
                                </div>
                                </div>
                            <div style={{fontSize:12 ,color:"red"}} className="left" >{this.state.firebaseJsonFile_err}</div>

                            </div>

                            {/* <div className="row">

                            <div className="file-field input-field">
                            
                            <span className="btn btn-file blue-grey">
                                        <i className="material-icons left">cloud_upload</i>
                                        Choose json file<input   id="firebaseJsonFile" type="file" onChange={this.handleChange} />
                             </span> 
                             <br/>  
                             <br/>
                            </div>
                            
                            
                            </div> */}
                            <div className="row">
                            {this.state.isloader?(<CirclePreloader style={{margin:0}} />):(
                                 (
                                    <div className="col-4 center">
                                    <button className="btn waves-effect waves-light blue-grey"  type="submit" name="action">Submit<i className="material-icons right">send</i>
                                    </button>
                                </div> 
                                )
                            )}
                                
                                </div> 
                               
                            </form>
                            </div>
                          </div>
                    
                    </div>
                    </div>
                    </div>
                  
 )
}
}
export default AddAppForm;
